import { isNumber, isString } from "../utils/schemaUtils";

export interface LinearProject {
  id: string;
  name: string;
  state: string;
  // Fraction of the project's issues completed, 0 through 1.
  progress: number;
  targetDate?: string;
  lead?: string;
  teams: string[];
  url: string;
  description?: string;
  startDate?: string;
  issueCount?: number;
}

const isLinearProject = (v: unknown): v is LinearProject => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.id) &&
    isString(r.name) &&
    isString(r.state) &&
    isNumber(r.progress) &&
    (r.targetDate === undefined || isString(r.targetDate)) &&
    (r.lead === undefined || isString(r.lead)) &&
    Array.isArray(r.teams) &&
    r.teams.every(isString) &&
    isString(r.url) &&
    (r.description === undefined || isString(r.description)) &&
    (r.startDate === undefined || isString(r.startDate)) &&
    (r.issueCount === undefined || isNumber(r.issueCount))
  );
};

export interface LinearProjectsPayload {
  type: "linear_projects";
  projects: LinearProject[];
}

export const parseLinearProjectsPayload = (v: unknown): LinearProjectsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "linear_projects") return null;
  if (!Array.isArray(r.projects) || !r.projects.every(isLinearProject)) return null;
  return {
    type: "linear_projects",
    projects: r.projects,
  };
};
